import { z } from 'zod';
/**
 * Rückmeldungen aus der laufenden Anwendung.
 *
 * Der Nutzer schreibt (oder diktiert) auf, was ihm auffällt; daraus entsteht
 * ein GitHub-Issue. Die Meldung wird immer zuerst gespeichert und erst danach
 * übermittelt — ein fehlender Token oder ein Netzausfall darf die Beobachtung
 * nicht verschlucken.
 */
export const FeedbackArt = z.enum(['fehler', 'wunsch']);
export const FeedbackStatus = z.enum(['offen', 'uebermittelt', 'fehlgeschlagen']);
export const FEEDBACK_ART_LABEL = {
    fehler: 'Fehler',
    wunsch: 'Wunsch',
};
export const FEEDBACK_STATUS_LABEL = {
    offen: 'Noch nicht übermittelt',
    uebermittelt: 'Als Issue angelegt',
    fehlgeschlagen: 'Übermittlung fehlgeschlagen',
};
export const createFeedbackRequest = z
    .object({
    art: FeedbackArt,
    titel: z.string().min(5).max(150),
    beschreibung: z.string().min(10).max(5000),
    /**
     * Pfad der Seite, auf der die Meldung entstand. Wird vom Frontend gesetzt
     * und spart im Regelfall die Rückfrage „wo genau war das?".
     */
    seite: z.string().max(300).optional(),
})
    .strict();
export const feedbackMeldung = z.object({
    id: z.number().int().positive(),
    art: FeedbackArt,
    titel: z.string(),
    beschreibung: z.string(),
    seite: z.string().nullable(),
    status: FeedbackStatus,
    githubNummer: z.number().int().nullable(),
    githubUrl: z.string().nullable(),
    fehlertext: z.string().nullable(),
    gemeldetVonName: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const feedbackListResponse = z.object({
    items: z.array(feedbackMeldung),
    total: z.number().int().nonnegative(),
    /**
     * Ist eine GitHub-Anbindung konfiguriert? Ohne sie sammelt die Anwendung
     * Meldungen nur ein — das muss der Admin sehen, sonst wartet er vergeblich
     * auf Issues.
     */
    githubKonfiguriert: z.boolean(),
});
